const numberNormalize = value => {
    const match = /(\d{0,9})[^.]*((?:\.\d{0,2})?)/g.exec(
        value.replace(/[^\d.]/g, "")
    );
    return match[1] + match[2];
};

export default numberNormalize